import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    create: {
        method: 'POST',
        url: `${BASE_PATH_API}/applicationPayments/:applicationId`
    },
    update: {
        method: 'PUT',
        url: `${BASE_PATH_API}/applicationPayments/:id`
    }
};

export interface IApplicationPaymentsApi {
    create(request: any): Promise<any>
    update(params: { id: number }, dto: any): Promise<any>
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function ApplicationPaymentsApi(): IApplicationPaymentsApi {
    return createActions(actions);
}
